import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SimpleProperty } from '@core';

@Component({
  selector: 'sbnb-add-task-rule-flow-property-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-task-rule-flow-property-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTaskRuleFlowPropertyDisplayComponent {
  property = input.required<SimpleProperty>();

  readonly formattedAddress = computed(() => {
    const prop = this.property();
    if (!prop?.location) return '';

    const parts: string[] = [];

    // Add street address with apartment if available
    if (prop.location.street) {
      let street = prop.location.street;
      if (prop.location.apt) {
        street += `, ${prop.location.apt}`;
      }
      parts.push(street);
    }

    // Add city, state, postcode line
    const cityStateZip: string[] = [];
    if (prop.location.city) cityStateZip.push(prop.location.city);
    if (prop.location.state) cityStateZip.push(prop.location.state);
    if (prop.location.postcode) cityStateZip.push(prop.location.postcode);

    if (cityStateZip.length > 0) {
      parts.push(cityStateZip.join(', '));
    }

    return parts.join(', ');
  });
}
